module.exports = __webpack_public_path__ + "static/img/2.af07900.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-th/2.jpg
// module id = Gfd6
// module chunks = 1